import store, { fetchAndSetUserCart, fetchAndSetUserFavourite, setAuthenticated } from '../../store/store';
import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { Switch } from "@headlessui/react";
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import ResetPwForm from './ResetPwForm';


const LoginForm = ({ returnUrl, setIsOpen, setModalTitle }) => {
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [isRememberMe, setIsRememberMe] = useState(false);
    const [isRegister, setIsRegister] = useState(false); // для переключения между Войти и Создать аккаунт

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [resetingPw, setResetingPw] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!email || !password) {
            setError("Заполните все поля");
            return;
        }
        if (isRegister && password !== confirmPassword) {
            setError("Пароли не совпадают");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`/Authorization/${isRegister ? 'Register' : 'Login'}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password, ...(confirmPassword && { confirmPassword }), isRememberMe, returnUrl })
            });

            const data = await response.json();

            if (response.ok) {
                if (setIsOpen)
                    setIsOpen(false);
                else {
                    if (data.returnUrl) {
                        window.location.href = data.returnUrl;
                    }
                    else window.location.href = "/home"
                    return;
                }
                // useEffect(() => {
                dispatch(fetchAndSetUserCart());
                dispatch(fetchAndSetUserFavourite());
                dispatch(setAuthenticated(true));
                // }, [dispatch]);
            } else {
                setError(data.message || `Ошибка ${isRegister ? 'регистрации' : 'авторизации'}`);
            }
        } catch (err) {
            setError("Ошибка сети");
        }
        setLoading(false);
    };
    return resetingPw ? <ResetPwForm setModalTitle={setModalTitle} onSuccess={() => setIsOpen(false)} /> : <>

        {/* Навигация */}
        <div className="flex border-b mb-4">
            <button
                onClick={() => setIsRegister(false)}
                className={`flex-1 py-2 font-medium ${!isRegister ? 'text-black border-b-2 border-black' : 'text-gray-500'}`}
            >
                Войти
            </button>
            <button
                onClick={() => setIsRegister(true)}
                className={`flex-1 py-2 ${isRegister ? 'text-black border-b-2 border-black' : 'text-gray-500'}`}
            >
                Создать аккаунт
            </button>
        </div>

        {/* Форма входа */}
        <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
            <input
                type="email"
                placeholder="Email"
                className="border px-4 py-2 rounded-md"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <div className="space-y-4">
                <div className="relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Пароль"
                        className="border px-4 py-2 rounded-md w-full"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-3 text-gray-600"
                    >
                        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                </div>
            </div>
            {isRegister && (
                <div className="space-y-4">
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="border px-4 py-2 rounded-md w-full"
                            placeholder="Подтвердите пароль"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="absolute right-3 top-3 text-gray-600"
                        >
                            {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                        </button>
                    </div>
                </div>
            )}
            <div className="flex items-center space-x-2">
                <Switch
                    checked={isRememberMe}
                    onChange={setIsRememberMe}
                    className={`${isRememberMe ? "bg-black" : "bg-gray-300"
                        } relative inline-flex h-6 w-11 items-center rounded-full transition`}
                >
                    <span
                        className={`${isRememberMe ? "translate-x-6" : "translate-x-1"
                            } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                    />
                </Switch>
                <span>Запомнить меня</span>
            </div>
            {error && <p className="text-red-600 text-sm">{error}</p>}
            <a onClick={() => setResetingPw(!resetingPw)} className="text-blue-600 text-sm cursor-pointer">
                Забыли пароль?
            </a>
            <button type="submit" className="bg-black text-white py-2 rounded-md" disabled={loading}>
                {loading ? "Загрузка..." : isRegister ? "Зарегистрироваться" : "Войти"}
            </button>
            <button className="border py-2 rounded-md">
                Продолжить с одноразовым кодом
            </button>
        </form>

    </>
}

export default LoginForm;